import React from "react"
import { Helmet } from "react-helmet"

import OfferBase from "../../../components/offer"

const Offer = () => {
  return (
    <OfferBase offerTitle={'PRX-T33'}>
      <Helmet title={"PRX-T33 - Dent&Beauty | Świdnica"} />
    </OfferBase>
  )
}

export default Offer
